import React, { useState, useEffect } from "react";
import { Container, Row, Col, ButtonGroup, Progress } from "reactstrap";
import Button from "reactstrap/lib/Button";
import { MdPauseCircleOutline, MdPlayCircleOutline, MdVolumeUp, MdVolumeOff } from "react-icons/md";

const stories = require("../data/stories.json");

const ModelViewer = ({ width, height, options, mobile }) => {
  const [model, setModel] = useState(0);
  const [audio, setAudio] = useState("ANNIKA_DX.WAV");
  const [modelActive, setModelActive] = useState(false);

  let audioRef = React.createRef();

  const renderButtons = () => {
    let buttonArray = [];
    if (mobile) {
      return (
        <Container fluid className="model-selections-container">
          <Row>
            <Col xs="2">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div>
                  <h1
                    onClick={() => {
                      if (model > 0) {
                        setModel(model - 1);
                        setAudio(options[model - 1].toUpperCase() + "_DX.WAV");
                      }
                    }}
                  >
                    {"<"}
                  </h1>
                </div>
              </div>
            </Col>
            <Col xs="8">
              <div
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                className="selections-name-container"
              >
                <div>
                  <h1>{options[model]}</h1>
                  <h2 style={{ textAlign: "center" }}>{"(" + stories[options[model]].age + ")"}</h2>
                  <h2 style={{ textAlign: "center" }}>{stories[options[model]].diagnosis}</h2>
                </div>
              </div>
            </Col>
            <Col xs="2">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div>
                  <h1
                    onClick={() => {
                      if (model < 11) {
                        setModel(model + 1);
                        setAudio(options[model + 1].toUpperCase() + "_DX.WAV");
                      }
                    }}
                  >
                    {">"}
                  </h1>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      );
    } else {
      options.forEach((option, index, arr) => {
        buttonArray.push(
          <Button
            key={option}
            variant="link"
            onClick={() => {
              setModel(index);
              setAudio(option.toUpperCase() + "_DX.WAV");
            }}
            className="modelviewer-button"
          >
            <p style={{ fontFamily: model === index ? "StJudeSansBold" : "StJudeSansSemibold" }}>{option}</p>
          </Button>
        );
      });
      return buttonArray;
    }
  };

  function handleModelActive(active) {
    setModelActive(active);
  }

  const renderAudio = () => {
    return (
      <iframe
        src={"./audio_player/index.html?song=" + audio}
        frameBorder="no"
        width={500}
        title="audio"
        className="audio-player"
        ref={audioRef}
      />
    );
  };

  const renderModel = () => {
    return (
      <iframe
        // style={{ pointerEvents: modelActive ? "all" : "none" }}
        frameBorder="none"
        src={"/VR/HallOfHeroes/modelviewer.html?name=" + options[model].toLowerCase()}
        allowFullScreen={false}
        title={options[model]}
        scrolling="no"
        className="model-frame"
        height={500}
        width={500}
      ></iframe>
    );
  };

  if (mobile) {
    return (
      <div className="viewer-position">
        <Container className="viewer-container" fluid={true}>
          <Row>
            <Col xs="12" md="6" style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
              <div className="modelviewer-modelcontainer" onClick={() => handleModelActive(true)}>
                <div className="modelCircle"></div>
                {renderModel()}
              </div>
            </Col>

            <Col xs="12" md="1">
              {/* <div className="v-spacer"></div> */}
              <Row>
                <ButtonGroup className="modelviewer-buttongroup" vertical>
                  {renderButtons()}
                </ButtonGroup>
              </Row>
              {/* <div className="v-spacer"></div> */}
            </Col>

            <Col
              xs="12"
              md="3"
              style={{ display: "flex", justifyContent: "space-around", alignItems: "center", textAlign: "left" }}
            >
              <div>{renderAudio()}</div>
            </Col>
            <Col xs="12">
              <p className={"modelviewer-bodycopy"}>{stories[options[model]].summary}</p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  } else {
    return (
      <div className="viewer-position">
        <Container className="viewer-container" fluid={true}>
          <Row>
            <Col xs="12" md="1"></Col>
            <Col xs="12" md="1">
              <div className="v-spacer"></div>
              <Row>
                <ButtonGroup className="modelviewer-buttongroup" vertical>
                  {renderButtons()}
                </ButtonGroup>
              </Row>
              <div className="v-spacer"></div>
            </Col>

            <Col xs="12" md="6" style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
              <div className="modelviewer-modelcontainer" onClick={() => handleModelActive(true)}>
                <div className="modelCircle"></div>
                {renderModel()}
              </div>
            </Col>

            <Col
              xs="12"
              md="3"
              style={{ display: "flex", justifyContent: "space-around", alignItems: "center", textAlign: "left" }}
            >
              <div>
                {console.log(options.model)}
                <h1>{options[model] + " (" + stories[options[model]].age + ")"}</h1>
                <h2>{stories[options[model]].diagnosis}</h2>
                <p className={"modelviewer-bodycopy"}>{stories[options[model]].summary}</p>
                {renderAudio()}
              </div>
            </Col>
            <Col xs="12" md="1"></Col>
          </Row>
        </Container>
      </div>
    );
  }
};

export default ModelViewer;
